import React, { useState } from 'react'
import axios from 'axios';

export default function Contact(props) {
    const hostname = process.env.REACT_APP_HOSTNAME
    const [userInput, setUserInput] = useState({})

    const handleInput = (e) => {
        const { name, value } = e.target;
        setUserInput({
            ...userInput,
            [name]: value
        })
    }

    const submitData = async (e) => {
        e.preventDefault();
        try {
            await props.showAlert("Sending your message...", "red", 1000);
            await axios.post(hostname + '/api/sendMail', userInput);
            await props.showAlert("Message Sent! I will respond within 24 hours!", "lightgreen", 4000);
            e.target.reset();
            setUserInput({});
        } catch (error) {
            if (error?.response?.status === 429) {
                props.showAlert("Too many requests! Try again later", "red", 3000);
                return;
            }
            props.showAlert("Server Problem! Try again later", "red", 3000);
        }
    };

    return (
        <div
            className={`pb-4 ${props.mode === 'dark' ? 'bg-dark text-light' : ''}`}
            style={
                props.mode === 'dark'
                    ? { backgroundImage: 'url(https://i.ibb.co/nmSkQTC/background.jpg)' }
                    : { background: 'linear-gradient(45deg, #00bcd4,#ffeb3b)' }
            }
            data-bs-theme={props.mode}
        >
            <div
                id="contact"
                className="madimi-one-regular text-center content-heading-text"
            >
                Send me a message!
            </div>

            <hr className="w-50 m-auto mb-4" />

            <div className="container">
                <div className="row g-4 align-items-start">

                    {/* LEFT SECTION */}
                    <div className="col-12 col-lg-6" data-aos="fade-right" data-aos-duration="2000">

                        <h2 className="mb-4">Getting in touch is easy!</h2>

                        <div className="d-flex align-items-center mb-3">
                            <span className="material-symbols-outlined me-2">home_pin</span>
                            <span>Kathmandu, Nepal - 44600</span>
                        </div>

                        <div className="d-flex align-items-center mb-3">
                            <span className="material-symbols-outlined me-2">location_on</span>
                            <span>Bengaluru, Karnataka, India - 560037</span>
                        </div>

                        <div className="d-flex align-items-center mb-3">
                            <span className="material-symbols-outlined me-2">mail</span>
                            <a
                                href="mailto:contact@neupanesugam.com.np"
                                className="text-decoration-none text-danger"
                            >
                                contact@neupanesugam.com.np
                            </a>
                        </div>

                        <div className="d-flex align-items-center mb-3">
                            <i className="bi bi-whatsapp me-2"></i>
                            <span>(+91) XXX XXX XXXX</span>
                        </div>

                        <div className="mt-4">
                            <p className="mb-2">Find me on</p>

                            <div>
                                <a className={`btn btn-outline-${props.mode === 'dark' ? 'light' : 'primary'} m-1`}
                                    href="https://www.facebook.com/ns.neupane09/" target="_blank" rel="noreferrer">
                                    <i className="bi-facebook"></i>
                                </a>

                                <a className={`btn btn-outline-${props.mode === 'dark' ? 'light' : 'danger'} m-1`}
                                    href="https://www.instagram.com/ns_neupane09" target="_blank" rel="noreferrer">
                                    <i className="bi-instagram"></i>
                                </a>

                                <a className={`btn btn-outline-${props.mode === 'dark' ? 'light' : 'primary'} m-1`}
                                    href="https://www.linkedin.com/in/sugamneupane/" target="_blank" rel="noreferrer">
                                    <i className="bi-linkedin"></i>
                                </a>

                                <a className={`btn btn-outline-${props.mode === 'dark' ? 'light' : 'dark'} m-1`}
                                    href="https://github.com/NSugam" target="_blank" rel="noreferrer">
                                    <i className="bi-github"></i>
                                </a>
                            </div>
                        </div>

                    </div>

                    {/* RIGHT SECTION (FORM) */}
                    <div className="col-12 col-lg-6" data-aos="fade-left" data-aos-duration="2000">

                        <form onSubmit={submitData} id="contact-form">

                            <div className="mb-3">
                                <label className="form-label">Your Name *</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="name"
                                    placeholder="Full name"
                                    onChange={handleInput}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Email *</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    name="email"
                                    placeholder="@"
                                    onChange={handleInput}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Phone (optional)</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="phone"
                                    placeholder="+977 / +91"
                                    onChange={handleInput}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Message *</label>
                                <textarea
                                    className="form-control"
                                    rows="5"
                                    name="message"
                                    placeholder="Write your message..."
                                    onChange={handleInput}
                                    required
                                ></textarea>
                            </div>

                            <div className="text-end">
                                <button
                                    className={`btn btn-${props.mode === 'dark' ? 'light' : 'success'}`}
                                    type="submit"
                                >
                                    Send Message
                                </button>
                            </div>

                        </form>

                    </div>

                </div>
            </div>
        </div>
    )
}